export const domainRules = (t) => [
  { required: true, message: t("customEmail.setup.domain_required") },
  {
    pattern: /^(?!https?:\/\/)(?!www\.)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/,
    message: t("customEmail.setup.domain_invalid")
  }
]

export const emailRules = (t) => [
  { required: true, message: t("customEmail.from_address.required") },
  { type: "email", message: t("customEmail.from_address.invalid_email") }
]
